// N-15c: HOT 通知先の表示用サマリ（判定は functions と同じ `selectRecipientsForKind`）。
import {
  resolvePortalUrl,
  selectRecipientsForKind,
  type NotificationRecipientsDoc,
} from '@kawai/shared';

export interface HotRecipientsSummary {
  /** メールで受ける人の名前（名簿の `name`）。 */
  emailNames: string[];
  /** LINE で受ける人の名前。 */
  lineNames: string[];
}

export function summarizeHotRecipients(
  registry: NotificationRecipientsDoc | null,
): HotRecipientsSummary {
  if (!registry) return { emailNames: [], lineNames: [] };
  const sel = selectRecipientsForKind(registry, 'hot');
  const byEmail = new Map<string, string>();
  const byLine = new Map<string, string>();
  for (const r of registry.recipients) {
    if (r.email) byEmail.set(r.email.toLowerCase(), r.name);
    if (r.lineUserId) byLine.set(r.lineUserId, r.name);
  }
  return {
    emailNames: sel.emails.map((e) => byEmail.get(e.toLowerCase()) ?? e),
    lineNames: sel.lineUserIds.map((id) => byLine.get(id) ?? id),
  };
}

/** tenant-portal「通知先登録」ページの URL（編集はそこで行う）。 */
export function notificationRecipientsPortalUrl(): string {
  return `${resolvePortalUrl(import.meta.env.MODE).replace(/\/$/, '')}/notification-recipients`;
}
